<mat-card appearance="outlined">
  <h2>{{ 'dynamicContent.openHours.title' | translate }}</h2>

  <div class="main-actions">
    <button *ngIf="displayRegularButton" (click)="editOpeningInfo('regular')" class="ibexfusion-raised-button small"
            mat-button>{{ 'dynamicContent.openHours.addRegularOpeningInfo' | translate }}</button>
    <button (click)="editOpeningInfo('span')" class="ibexfusion-raised-button small"
            mat-button>{{ 'dynamicContent.openHours.addSpanOpeningInfo' | translate }}</button>
    <button (click)="editOpeningInfo('day')" class="ibexfusion-raised-button small"
            mat-button>{{ 'dynamicContent.openHours.addDayOpeningInfo' | translate }}</button>
  </div>

  <div class="table-header">
    <div class="title">{{'general.title' | translate}}</div>
    <div class="actions"></div>
  </div>

  <div class="table" *ngIf="dynamicContent?.content?.openingInfo?.length">
    <div *ngFor="let item of dynamicContent.content.openingInfo; let i = index" class="table-row">
      <div class="title">{{ getTitle(item) }}</div>
      <div class="active" *ngIf="isActive(item)" [matTooltip]="'general.active' | translate"></div>
      <div class="actions">
        <button (click)="editOpeningInfo(null, i)" class="ibexfusion-icon-button" mat-icon-button>
          <mat-icon>edit</mat-icon>
        </button>
        <button (click)="removeOpeningInfo(i)" class="ibexfusion-icon-button" mat-icon-button>
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <p *ngIf="!dynamicContent?.content?.openingInfo?.length" class="no-file">{{ 'dynamicContent.noOpeningInfo' | translate }}</p>

</mat-card>
